import {getMinute, getTimeHH} from "../../../utility/DateUtils";
import React from "react";


const Header = ({drawAt}) => {
    return <div className="top">
        <div className="bkl">
            <div className="bkr">
                <div className="bkm">
                    <div className="icon"><span
                        className="icon_old"/></div>
                    <div className="title">
                        <a href="/">KẾT QUẢ XỔ SỐ Miền Trung</a> - <a
                        href="/">{getTimeHH(drawAt)}H{getMinute(drawAt)}'</a>
                    </div>
                    <div className="iconright">
                        <a className="icontk" title="Xem thống kê chi tiết xổ số Miền Trung"
                           href="/"><span/></a>
                    </div>
                    <div className="iconrightkq">
                        <a className="iconkq" title="Xem kết quả xổ số Miền Trung theo bảng tỉnh"
                           href="/"><span>Xem bảng tỉnh...</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default Header;